import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ReactComponent as ArrowRight } from 'src/assets/arrow-long-right.svg';
import PageHeader from 'src/components/page-header/page-header';
import { ContactBlock, ContactFilters, ContactFormProps } from 'src/types';
import BlockCard from './block-card';
import ContactBlockView from './contactCard';
import css from './contacts.module.scss';
import { useGetBlocks, useGetContacts } from './data/queries';
import EmptyPlaceholder from './empty-placeholder';
import SearchForm from './filters/filter';
import Sceletons from './sceletons';

function Contacts() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState<ContactFilters>({
    search: searchParams?.get('search') ?? ''
  });

  const { data: blocks = [] } = useGetBlocks();
  const { data: contact, isFetching } = useGetContacts(filter);

  function handleFiltersChange(newfilters: ContactFormProps) {
    const nextSearchParams = new URLSearchParams(searchParams);
    setFilter({ ...filter, ...newfilters });
    newfilters?.search ? nextSearchParams.set('search', newfilters?.search) : nextSearchParams.delete('search');
    if (nextSearchParams.toString() !== searchParams.toString()) setSearchParams(nextSearchParams);
  }

  return (
    <main className={css.contacts}>
      <PageHeader
        title='Каталог контактів'
        description='ТЦК та СП, служби супроводу, КШППВ.'
        filter={<SearchForm initialValues={{ search: filter.search }} onSubmit={handleFiltersChange} />}
      />
      <div className={css.body}>
        <div className={css.content}>
          <BlockCard blocks={blocks} />
          {!isFetching && contact?.length === 0 && <EmptyPlaceholder />}
          {isFetching && <Sceletons />}
          <div className={css.list}>
            {contact?.map((block: ContactBlock) => (
              <React.Fragment key={block.id}>
                <div className={css.block}>
                  <div className={css.blockInfo}>
                    <Link to={block.slug}>
                      ВСІ {block.title.toUpperCase()} <ArrowRight />
                    </Link>
                    <h3>{block.title}</h3>
                  </div>
                </div>
                <ContactBlockView key={block.id} cards={block.cards} blockId={block.id} blockTitle={block.title} />
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}

export default Contacts;
